<template>
  <v-card>
    <v-card-title class="px-0">
      <v-spacer></v-spacer>
       <v-btn
        color="primary"
        class="mr-0"
        @click="getQuestionFlow"
      >
        Refresh Question Flow
      </v-btn>
      <v-btn
        v-if="!showcomponentManager"
        color="primary"
        class="mr-0"
        @click="generateQuestionFlow"
      >
        {{questionList.length > 0 ? 'Reset' : 'Generate' }} Question Flow
      </v-btn>
    </v-card-title>
      <v-card>
        <v-layout column>
          <div v-for="(question, index) in questionList" :key="index">
            <v-flex style="overflow: auto">
      
              <v-expansion-panel expand v-if="question.type != 'TEXT' && question.type != 'CHECK' " class="mb-2">
                  <v-expansion-panel-content>
                      <template slot="header">
                          <div>
                            <v-layout row wrap>
                              <v-text-field 
                                  label="Order"
                                  :value="question.order"
                                  disabled
                                  class="shrink"
                                  style="width:50px"
                                ></v-text-field>
                                <v-text-field
                                  :value="question.title"
                                  label="Question title"
                                  class="ml-2"
                                  disabled
                                ></v-text-field>
                                <v-text-field
                                  :value="question.type"
                                  label="type"
                                  class="ml-2 mr-2 shrink"
                                  style="width:100px"
                                  disabled
                                ></v-text-field>
                            </v-layout>
                          </div>                   
                      </template>
                      <v-card class="ml-5">
                        <div class="ml-0">
                          Options
                        </div>
                          <v-container grid-list-xl>
                            <v-layout row wrap>
                                <v-flex xs12>
                                  <v-layout row wrap v-for="(option, i) in question.options" :key="i">
                                    <v-text-field
                                      :value="option.title"
                                      label="Option title"
                                      class="ml-2"
                                      disabled
                                    ></v-text-field>
                                    <v-select
                                      :disabled="showcomponentManager"
                                      v-model="option.next_question_id"
                                      :items="generateQuestionSelect(question.id)"
                                      item-text="title"
                                      item-value="value"
                                      label="Select Next Question"
                                      persistent-hint
                                      return-object
                                      single-line
                                      @input="updateFlowQuestion(option)"
                                      class="ml-2 mr-2 shrink"
                                      style="width:300px"
                                    ></v-select>
                                  </v-layout>
                                </v-flex>
                            </v-layout>
                          </v-container>
                          <br>
                      </v-card>
                  </v-expansion-panel-content>
              </v-expansion-panel>
            </v-flex>
            <div style="overflow: hidden" class="pt-2 pr-3 pl-3 ml-3" v-if="question.type == 'CHECK' || question.type == 'TEXT'">
              <v-layout row wrap>
                <template>
                  <v-text-field 
                      label="Order"
                      :value="question.order"
                      class="ml-1 shrink"
                      style="width:50px"
                      disabled
                    ></v-text-field>
                    <v-text-field
                      :value="question.title"
                      label="Question title"
                      class="ml-2"
                      disabled
                    ></v-text-field>
                    <v-text-field
                      :value="question.type"
                      label="type"
                      class="ml-3 shrink"
                      style="width:80px"
                      disabled
                    ></v-text-field>
                    <v-select
                      :disabled="showcomponentManager"
                      v-model="question.next_question_id"
                      :value="question.next_question_id"
                      :items="generateQuestionSelect(question.id)"
                      item-text="title"
                      item-value="value"
                      label="Select Next Question"
                      persistent-hint
                      single-line
                      class="ml-3 shrink"
                      style="width:400px"
                      @input="updateFlowQuestion(question)"
                    >
                    </v-select>
                </template>
              </v-layout>
            </div>
          </div>
        </v-layout>
    </v-card>
    
  </v-card>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    
  },
  props: {
    round: {
      type: Object,
      required: true
    }
  },
  
  data () {
    return {
      questionList: [],
      questionSelect: [],
      showModal: {
        createQuestion: false,
      },
    };
  },
  computed: {
    ...mapGetters(['currentUser']),
    showcomponentManager: function () {
      if (this.currentUser.role === 'manager') {
        return true;
      }
      return false;
    }
  },
  mounted () {
    this.getQuestionFlow();
  },
  methods: {
    ...mapActions(['setSnackbar', 'setLoading']),
    getQuestionFlow () {
      let _self = this;
      let url = `questions/rounds/${this.round.id}/get-question-flow`;
      window.axios.get(url).then((response) => {
        this.questionList = response.data;
        this.questionSelect = this.questionList.map(function (question) {
          let questionAux = {
            'value': question.id,
            'title': `${question.order} - ${question.title}`
          };
          return questionAux;
        });

        this.questionSelect.push({
          'value': 'end',
          'title': `${this.questionSelect.length - 1} - End`
        });        
      });
    },
    generateQuestionSelect (questionId) {
      return this.questionSelect.filter(function (question) {
        return questionId !== question.value && questionId && question.next_question_id !== 'end';
      });
    },
    updateFlowQuestion (question) {
      let url = `questions/rounds/${this.round.id}/update-question-flow`;
      const payload = {
        question: {
          id: question.id,
          next_question_id: typeof question.next_question_id.value === 'undefined' ? question.next_question_id : question.next_question_id.value
        },
      };
      window.axios.put(url, payload).then(response => {
      });
    },
    generateQuestionFlow () {
      let url = `questions/rounds/${this.round.id}/generate-question-flow`;
      window.axios.get(url).then((response) => {
        this.getQuestionFlow();       
      });

    }
    
  }
};
</script>
<style>
  .d-flex{
    display: flex;
  }
  .text-center{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/client/questions/QuestionsFlow.vue